import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {TranslateModule} from '@ngx-translate/core';
import {IconButtonComponent, SelectModule} from '@q9elements/ui-kit/components';
import {FullColorPickerComponent} from '../../../shared/full-color-picker/full-color-picker.component';
import {FONTS, getFontSizes} from 'src/app/shared/constants/fonts.constants';

@Component({
  selector: 'app-font-configs',
  templateUrl: './font-configs.component.html',
  styleUrls: ['./font-configs.component.scss', '../shared.styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FullColorPickerComponent,
    TranslateModule,
    FormsModule,
    SelectModule,
    IconButtonComponent,
    MatExpansionModule,
    MatDividerModule
  ]
})
export class FontConfigsComponent {
  protected readonly fonts = FONTS;
  protected readonly fontSizes = getFontSizes();

  @Input() styleObj: any;
  @Input() controlsMode: number;
  @Input() configsShown?: boolean;
  @Input() buttonsEnabled?;
  @Input() listFormatEnabled = false;
  @Input() isCollapse = true;
  @Output() switchFont: EventEmitter<any> = new EventEmitter();
  @Output() fontColorSwitch: EventEmitter<any> = new EventEmitter<any>();
  @Output() toggleUnorderedList: EventEmitter<void> = new EventEmitter<void>();
  @Output() toggleOrderedList: EventEmitter<void> = new EventEmitter<void>();

  handleSwitchFont(param, val?) {
    this.switchFont.emit({param, val});
  }

  throwUp(color) {
    this.fontColorSwitch.emit(color);
  }

  public handleToggleUnorderedList() {
    this.toggleUnorderedList.emit();
  }

  public handleToggleOrderedList() {
    this.toggleOrderedList.emit();
  }
}
